export class LocationCarrierCmaLiteConfigurationUpdateRequest {
  public enabledCarriers: string[] = [];

  toDto(): any {
    return {
      enabledCarriers: this.enabledCarriers
    };
  }
}
